<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsSexo"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsSexo"
          addFilter
          :items="listarSexo"
        >
        </fccTable>
      </div>
    </div>
    <fccModal centered idModal="editSexo" :titleModal="titleModal" escondeFooter travaEsc travaBack>
      <form @submit.prevent="sexo.id === 0 ? addSexo() : editandoSexo()" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="sexo.descricao">Descrição</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Sexo',
      titleModal: '',
      titlePDF: 'Sexo',
      listarSexo: [],
      baseUrlGestaoProjetosConcurso: '',
      sexo: [],
      itemPorPage: '100',
      actionsSexo: [
        {
          button: true,
          funcaoButton: 'editSexo',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteSexo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsSexo: [
        { key: 'idsexo', label: 'ID', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoSexo() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'Sexo/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarSexo = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField() {
      this.titleModal = 'Adicionar sexo'
      this.sexo = {}
      this.sexo.id = 0
      this.$root.$emit('bv::show::modal', 'editSexo')
    },
    editSexo(_, item) {
      this.titleModal = 'Editar sexo'
      this.sexo = item
      this.$root.$emit('bv::show::modal', 'editSexo')
    },
    editandoSexo() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'Sexo/Alterar',
          this.sexo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.sexo = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editSexo')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addSexo() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'Sexo/Adicionar',
          this.sexo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.sexo = {}
          this.listandoSexo()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editSexo')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteSexo(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'Sexo/Excluir/' + item.idsexo,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoSexo()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted() {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoSexo()
  }
}
</script>
